class BlogImageBannerNav extends HTMLElement {
  connectedCallback() {
    this.pills = this.querySelector(".fp-blog-image-banner__pills");
    if (!this.pills) return;
    this.check = this.check.bind(this);
    this.resizeObserver = new ResizeObserver(this.check);
    this.resizeObserver.observe(this);
    requestAnimationFrame(this.check);
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  check() {
    this.classList.add("is-measuring");
    const style = getComputedStyle(this.pills);
    const paddingLeft = parseFloat(style.paddingLeft) || 0;
    const paddingRight = parseFloat(style.paddingRight) || 0;
    const gap = parseFloat(style.columnGap || style.gap) || 0;
    const items = this.pills.children;
    let contentWidth = 0;
    for (let i = 0; i < items.length; i++) {
      contentWidth += items[i].offsetWidth;
      if (i > 0) contentWidth += gap;
    }
    const available = this.pills.clientWidth - paddingLeft - paddingRight;
    this.classList.remove("is-measuring");
    // Inverted from "is-pills-fit": CSS now defaults to pills shown at >= 768px.
    // We only flip back to the mobile dropdown when pills overflow.
    this.classList.toggle("is-pills-overflow", contentWidth > available);
  }
}

customElements.define("blog-image-banner-nav", BlogImageBannerNav);
